interface Message {
  [key: string]: any
}

const sendToIframe = (msg: Message, iframeTitle: string) => {
  const iframe = document.querySelector(`iframe[title="${iframeTitle}"]`) as HTMLIFrameElement

  iframe?.contentWindow?.postMessage(JSON.stringify(msg), '*')
}

window.sendToIframe = sendToIframe

export default sendToIframe
